export enum FormState {
  LOADING = 1,
  INITIAL = 2,
  SUBMITTING = 3,
  ERROR = 4,
  SUCCESSFULL = 5
}
